module.exports = __webpack_public_path__ + "static/media/service-1.1d40f1e9.jpg";